import React from "react";
import ScrollToTop from "../ScrollToTop/ScrollToTop";
import LoadingScreen from "./LoadingScreen";
import FloatingSupport from "./FloatingSupport";
import { Toaster } from "react-hot-toast";
import DynamicMetatag from "./DynamicMetatag";
import SomeSpace from "./SomeSpace";

const AllExtraComponantInOne = () => {
  return (
    <>
      <SomeSpace />
      <DynamicMetatag />
      <FloatingSupport />
      <ScrollToTop />
      {/* <LoadingScreen /> */}
      <Toaster
        position="top-right"
        reverseOrder={false}
        gutter={8}
        pauseDuration={2000}
      />
    </>
  );
};

export default AllExtraComponantInOne;
